// FormButton Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IntlMessage from '../../common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class FormButton extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      type: PropTypes.string,
      secondary: PropTypes.bool,
      enabled: PropTypes.bool,
      onClick: PropTypes.func,
      className: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      title: '',
      type: '',
      secondary: false,
      enabled: true,
      onClick: null,
      className: null
    }
  }

  render () {
    const classes = classnames(
      'form-button',
      {
        'form-button__secondary': this.props.secondary
      },
      this.props.className
    )
    const titleConvert = this.props.title
      ? IntlUtil.convertMessage(this.props.title)
      : ''

    return (
      <button
        className={classes}
        type={this.props.type}
        title={titleConvert}
        onClick={this.props.onClick}
        disabled={!this.props.enabled}
      >
        <IntlMessage ident={this.props.title} />
      </button>
    )
  }
}

export default FormButton
